import React from 'react';
import { Provider } from 'react-redux';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThemeProvider } from 'styled-components';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import { getRoutes } from './routes';
import configureStore from './app/store/configureStore';
import history from './app/history';
import { getDataObject, getUrlData, getGalleryData, theme } from './server-utils';
import { ddoInit, ddoEventInit } from './app/utils/analytics/_digitalData';


NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());

  if (client.customer.type === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }

  const { omsId } = getUrlData(window.location.pathname);

  const dataObject = await getDataObject(client, omsId);
  const galleryData = await getGalleryData(client, dataObject);

  const hydratedStoreInitialState = { ...dataObject, gallery: galleryData };

  const { store } = configureStore({ ...hydratedStoreInitialState });

  window.ddoInit = ddoInit;
  window.ddoEventInit = ddoEventInit;

  client.render(
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <App
          history={history}
          store={store}
          data={dataObject}
          prefetchPip={client.featureSwitches.prefetchPip}
          productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
        />
      </Provider>
    </ThemeProvider>
  );
});
